import faker from 'faker';
import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { set, sub, formatDistanceToNow } from 'date-fns';
import { Icon } from '@iconify/react';
import bellFill from '@iconify/icons-eva/bell-fill';
import clockFill from '@iconify/icons-eva/clock-fill';
import doneAllFill from '@iconify/icons-eva/done-all-fill';
import closeOutline from '@iconify/icons-eva/close-outline';
import { useTranslation } from 'react-i18next';
// material
import { alpha } from '@mui/material/styles';
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  IconButton,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton
} from '@mui/material';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
// utils
import { mockImgAvatar } from '../../utils/mockImages';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';

// ----------------------------------------------------------------------

function NotificationItem({ notification, readFunc, deleteNotif }) {
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  return (
    <div style={{ position: 'relative', zIndex: 2, display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={() => deleteNotif(notification.id)}
        style={{ color: '#f78181', position: 'absolute', right: 10, zIndex: 6 }}
      >
        <Icon icon={closeOutline} width={15} height={15} style={{ zIndex: 6 }} />
      </IconButton>
      <ListItemButton
        to={`/dashboard/notification/${notification.id}`}
        onClick={() => readFunc(notification.id)}
        disableGutters
        component={Link}
        sx={{
          py: 1.5,
          px: 2.5,
          mt: '1px',
          ...(notification.unread && {
            bgcolor: 'action.selected'
          })
        }}
      >
        <ListItemAvatar>
          <Avatar
            sx={{ bgcolor: 'background.neutral' }}
            src={`${API_ENDPOINT}${notification.created_by.photo}`}
          />
        </ListItemAvatar>
        <ListItemText
          primary={notification.created_by.username}
          secondary={
            <>
              <Typography style={{ color: 'black' }}>{notification.title}</Typography>
              <Typography>{notification.text.slice(0, 10)} ...</Typography>
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  color: 'text.disabled'
                }}
              >
                <Box
                  component={Icon}
                  icon={clockFill}
                  sx={{ mr: 0.5, width: 16, height: 16, color: '#f78181' }}
                />
                {formatDistanceToNow(new Date(notification.created_at))}
              </Typography>
            </>
          }
        />
      </ListItemButton>
    </div>
  );
}

export default function NotificationsPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState([]);
  const [result, setResult] = useState([]);
  const [notifUnRead, setNotifUnread] = useState([]);
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();

  // GET all notifUNRead
  const UnreadNotif = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/unread-notifications/`,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  };

  useEffect(async () => {
    const all = await UnreadNotif();
    console.log('unread', all);
    if (all) setNotifUnread(all);
  }, []);

  // PAGINATION
  const retrievePagination = async () => {
    console.log('apiiii', result.next);
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: result.next,
      headers: { Authorization: `Bearer ${token}` }
    });
    setResult(response.data);
    console.log('RESULT 222***', response.data);
    setNotification((oldData) => [...oldData, ...response.data.results]);
  };

  // GET all notification
  const retrieveNotif = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/my-notifications/`,
      headers: { Authorization: `Bearer ${token}` }
    });
    setResult(response.data);
    return response.data.results;
  };

  useEffect(async () => {
    const all = await retrieveNotif();
    console.log('Notif***', all);
    if (all) setNotification(all);
  }, []);

  useEffect(() => {
    const interval = setInterval(async () => {
      const all = await retrieveNotif();
      console.log('Notif***', all);
      if (all) setNotification(all);
      const unread = await UnreadNotif();
      console.log('unread', unread);
      if (unread) setNotifUnread(unread);
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMarkAllAsRead = () => {
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('access');
    axios({
      method: 'PUT',
      url: `${API_ENDPOINT}/api/read-notifications/`,
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => {
        console.log('response reaaaad', res);
        setNotification(
          notification.map((notification) => ({
            ...notification,
            unread: false
          }))
        );
        setNotifUnread(() => ({
          notifications_count: 0,
          unread_notification: false
        }));
      })
      .catch((err) => {
        console.log('err read', err);
      });
  };
  const handleMarkAsRead = (id) => {
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('access');
    const formData = new FormData();
    formData.append('notification_id', id);
    axios({
      method: 'PUT',
      url: `${API_ENDPOINT}/api/read-notification/`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      data: formData
    })
      .then((res) => {
        console.log('response read one', res);
        setNotification(
          notification.map((notification) => {
            if (notification.id === id) {
              notification.unread = false;
            }
            return notification;
          })
        );
        setNotifUnread(() => ({
          notifications_count:
            notifUnRead.notifications_count > 0 ? notifUnRead.notifications_count - 1 : 0,
          unread_notification: notifUnRead.notifications_count === 0 && false
        }));
      })
      .catch((err) => {
        console.log('err read', err);
      });
  };

  const deleteNotif = (ID) => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const dataa = { notification_id: ID };
    axios({
      method: 'delete',
      url: `${API_ENDPOINT}/api/notifications/`,
      headers: { Authorization: `Bearer ${token}` },
      data: dataa
    })
      .then((res) => {
        console.log('delete', ID);
        const newNotifList = notification.filter((c) => c.id !== ID);
        setNotification(newNotifList);
        if (window.location.pathname === `/dashboard/notification/${ID}`) {
          navigate('/dashboard');
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  /* setNotifications(
      notifications.map((notification) => ({
        ...notification,
        isUnRead: false
      }))
    ); */

  return (
    <>
      <IconButton
        ref={anchorRef}
        size="large"
        style={{ color: open ? 'grey' : '#f78181' }}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <Badge badgeContent={notifUnRead.notifications_count} color="error">
          <Icon icon={bellFill} width={25} height={25} />
        </Badge>
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 360, maxHeight: 500, overflowY: 'auto', overflowX: 'hidden' }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">{t('notifications')}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {t('Vousavez', { val: notifUnRead.notifications_count })}
            </Typography>
          </Box>

          {notifUnRead.notifications_count > 0 && (
            <Tooltip title={t('Mark all as read')}>
              <IconButton style={{ color: '#f78181' }} onClick={handleMarkAllAsRead}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Divider />

        <Scrollbar sx={{ height: { xs: 340, sm: 'auto' } }}>
          <List disablePadding>
            {notification.map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                readFunc={handleMarkAsRead}
                deleteNotif={deleteNotif}
              />
            ))}
          </List>
        </Scrollbar>

        <Divider />
        {result.next != null && (
          <Box sx={{ p: 1 }}>
            <Button fullWidth disableRipple onClick={retrievePagination}>
              {t('ViewAll')}
            </Button>
          </Box>
        )}
      </MenuPopover>
    </>
  );
}
